import React, { useEffect } from "react"
import ReactGA from "react-ga4"
import { useLocation } from 'react-router-dom'
import { useMutation, gql } from '@apollo/client'

const pageviewMutation = gql`
mutation($url: String!, $referrer: String) {
  pageview(
    url: $url, 
    referrer: $referrer
  ),
}
`

function GaTracker(props) {
  const location = useLocation()
  const [pageviewTrigger
  ] = useMutation(pageviewMutation, {
    onCompleted: (data) => {

    },
    errorPolicy: 'all'
  })
  
  const trackPage = React.useCallback((page) => {
    ReactGA.set({
      page,
      ...props.options
    });
    ReactGA.send({ hitType: "pageview", page });
  }, [props.options])

  const GA_ID = process.env.REACT_APP_GA_GA_ID
  useEffect(() => {
    if (GA_ID) {
      console.debug("GaTracker will initialize ga")
      ReactGA.initialize(GA_ID);
    }
  }, [GA_ID]);

  useEffect(
    () => {
      console.debug("URL changed, track")
      trackPage(location.pathname+location.search)
      pageviewTrigger({variables: {
        url: window.location.pathname+location.search,
        referrer: document?.referrer
      }})
    }, 
    [location.pathname, location.search, trackPage, pageviewTrigger]
  );

  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  );
};

export default GaTracker
